import { Moment } from 'moment';
import { Project as DashboardProject } from '../../../common/dashboards/models/Project';

export class Project extends DashboardProject {
  constructor(id: number, uuid: string, name: string, lastAnalysis: Moment | null) {
    super(id, uuid, name, lastAnalysis);
  }
}
